// The assistant's log of what it did. A run of the same action (the same
// habit marked done day after day) folds into one line that can be opened,
// instead of a line per day.

const shortDay = (day) => {
  const [y, m, d] = day.split('-').map(Number);
  return new Date(y, m - 1, d).toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
};

// "DARE: done on 54 days, Aug 1 to Sep 23" (no dashes in the assistant's voice)
export const groupText = (label, dates) => {
  const sorted = [...new Set(dates)].sort();
  return `${label} on ${sorted.length} days, ${shortDay(sorted[0])} to ${shortDay(sorted[sorted.length - 1])}`;
};

/**
 * The log with one more action: `outcome` is runTool's { summary, group }.
 * When the last line is the same group, it's folded into that line.
 */
export const withAction = (list, { summary, group }, id) => {
  const last = list[list.length - 1];
  if (group && last?.kind === 'action' && last.group?.key === group.key) {
    // Marking a day twice is allowed (it's a no-op), so days are counted once
    const dates = last.group.dates.includes(group.date) ? last.group.dates : [...last.group.dates, group.date];
    return [...list.slice(0, -1), { ...last, group: { ...last.group, dates }, text: groupText(group.label, dates) }];
  }
  return [...list, {
    id,
    kind: 'action',
    text: summary,
    ...(group ? { group: { key: group.key, label: group.label, dates: [group.date] } } : {}),
  }];
};
